export function isMagazineAd(item) {
    return item?.type === "MagazineAd";
}
export function isQuarterPageAd(item) {
    return item?.type === "QuarterPageAd";
}
export function isHalfPageAd(item) {
    return item?.type === "HalfPageAd";
}
export function isFullPageAd(item) {
    return item?.type === "FullPageAd";
}
export function isMagazineAdDeposit(item) {
    return item?.type === "MagazineAdDeposit";
}
export function isDoubleDeposit(item) {
    return item?.type === "DoubleDeposit";
}
//# sourceMappingURL=magazine-ad.js.map